import Typography from '@mui/material/Typography'
import React from 'react'

// Wrapper function that adds italic based on a condition
export const ItalicWrapper = ({ isItalic, children }) => {
    return <Typography sx={{ fontStyle: isItalic ? 'italic' : 'normal' }}>{children}</Typography>
}
